import { useState } from "react";
import { discussions, communityBg } from "@/mocks/chiagua";

const avatarColor = [
  "bg-primary-200 text-primary-900",
  "bg-accent-200 text-accent-900",
  "bg-secondary-200 text-secondary-900",
  "bg-foreground-200 text-foreground-800",
];

const pollOptions = [
  { text: "相信，坐等实锤", votes: 4521 },
  { text: "纯炒作，不站队", votes: 3180 },
  { text: "吃瓜看戏就完事", votes: 2764 },
];

export default function Discussion() {
  const [liked, setLiked] = useState<number[]>([]);
  const [poll, setPoll] = useState<number | null>(null);

  const toggleLike = (idx: number) =>
    setLiked((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]));

  return (
    <section id="discuss" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">Community Talk</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">社区讨论区 · 一起来吃瓜</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              理性吃瓜、友好交流，各路老饕在这里交换信息差。你也来说两句，说不定能补上关键的一块瓜。
            </p>
          </div>
          <a
            href="#join"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            <i className="ri-edit-2-line"></i> 发帖聊聊
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:col-span-2">
            <ul className="divide-y divide-background-100">
              {discussions.map((d, idx) => (
                <li key={d.title} className="p-4 md:p-5">
                  <div className="flex items-start gap-3">
                    <span
                      className={
                        "flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold " +
                        avatarColor[idx % avatarColor.length]
                      }
                    >
                      {d.author.slice(0, 1)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs font-medium text-secondary-800">
                          {d.forum}
                        </span>
                        <span className="rounded bg-primary-100 px-1.5 py-0.5 text-xs font-medium text-primary-700">
                          {d.tag}
                        </span>
                        {d.hot && (
                          <span className="flex items-center gap-0.5 text-xs text-primary-600">
                            <i className="ri-fire-line"></i> 热议
                          </span>
                        )}
                      </div>
                      <a href="#discuss" className="mt-1.5 block cursor-pointer">
                        <h3 className="text-sm font-semibold text-foreground-900 hover:text-primary-700 md:text-base">{d.title}</h3>
                      </a>
                      <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                        <span>@{d.author}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line"></i> {d.replies}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i> {d.views}
                        </span>
                        <span>{d.time}</span>
                        <button
                          type="button"
                          onClick={() => toggleLike(idx)}
                          className={
                            "ml-auto flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 transition-colors " +
                            (liked.includes(idx)
                              ? "border-primary-300 bg-primary-50 text-primary-700"
                              : "border-background-200 text-foreground-500 hover:border-primary-200 hover:text-primary-600")
                          }
                        >
                          <i className={liked.includes(idx) ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                          {liked.includes(idx) ? "已赞" : "点赞"}
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative h-28 w-full">
                <img src={communityBg} alt="社区讨论氛围" title="吃瓜福利 社区讨论" className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <p className="absolute bottom-3 left-4 font-heading text-base font-bold text-background-50">今日话题投票</p>
              </div>
              <div className="p-4">
                <p className="text-sm font-semibold text-foreground-900">这波顶流官宣瓜，你信还是不信？</p>
                <div className="mt-3 flex flex-col gap-2">
                  {pollOptions.map((o, i) => (
                    <button
                      key={o.text}
                      type="button"
                      onClick={() => setPoll(i)}
                      className={
                        "flex cursor-pointer items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm transition-colors " +
                        (poll === i
                          ? "border-primary-400 bg-primary-50 text-primary-800"
                          : "border-background-200 text-foreground-700 hover:border-primary-200")
                      }
                    >
                      <span className="flex items-center gap-2">
                        <i className={poll === i ? "ri-checkbox-circle-fill text-primary-500" : "ri-checkbox-circle-line"}></i>
                        {o.text}
                      </span>
                      <span className="text-xs text-foreground-500">{o.votes.toLocaleString()} 票</span>
                    </button>
                  ))}
                </div>
                <p className="mt-3 text-xs text-foreground-500">投票后可查看实时占比，理性表达请勿引战。</p>
              </div>
            </div>

            <div className="rounded-2xl border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-center gap-2 text-sm font-semibold text-accent-900">
                <i className="ri-question-line"></i> 社区发言守则
              </p>
              <ul className="mt-3 flex flex-col gap-2 text-xs leading-relaxed text-accent-800">
                <li>· 瓜料请标注来源，空口无凭慎发。</li>
                <li>· 尊重每一位当事人，拒绝人身攻击。</li>
                <li>· 尊重每一位网友，友好讨论不吃情绪。</li>
                <li>· 违规则会被禁言，共建清爽吃瓜环境。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}